module.exports = __webpack_public_path__ + "bf0fb23f59a4f53ed26f9070505a5a3e.svg";